import { render, staticRenderFns } from "./stock-adjustment.vue?vue&type=template&id=da16603a"
import script from "./stock-adjustment.vue?vue&type=script&lang=js"
export * from "./stock-adjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports